// extracted by mini-css-extract-plugin
export default {"root":"AccessRestricted_root__jtcNH","icon":"AccessRestricted_icon__vMbp6"};